import questions from "../../assets/questions/questions.dr.json";
import "./questionImage.css";
import { useEffect, useRef } from "react";
import CloudinaryImg from "./CloudinaryImg";

export default function QuestionImage({ serieNbr, questionNbr }) {
  const [q1, q2, c1, c2, c3, c4, url] = Object.values(
    questions[`serie${serieNbr}`]?.[questionNbr] || {}
  );
  // show choices side to side just in case of choices containing one word!
  const isSmallString =
    [c1, c2, c3, c4].filter((e) => e?.d !== "").length !== 3 &&
    [c1, c2, c3, c4].every((e) => e?.d.length < 7);
  const choicesStyle = isSmallString
    ? { display: "flex", justifyContent: "space-around" }
    : {};

    const imageRef = useRef()

  useEffect(()=>{
    const image = imageRef.current;
    if(image){
      const onDoubleClick = ()=>{
        const fullscreenElement  = document.fullscreenElement || document.webkitFullscreenElement;
        if(!fullscreenElement){
            if(image.requestFullscreen){
                // image.style.height = "auto"
                image.requestFullscreen();
              }else if(image.webkitRequestFullscreen){
              // image.style.height = "100%"
                image.webkitRequestFullscreen();
            }; 
        }else{
             if(document.exitFullscreen){
                document.exitFullscreen();
             }else if(document.webkitExitFullscreen){
                document.webkitExitFullscreen()
             };
        }
     };
      image.addEventListener("dblclick", onDoubleClick)
     return ()=>{
      image.removeEventListener("dblclick", onDoubleClick);
     }
    }
  }, [imageRef])
  return (
    <>
      <div ref={imageRef} id="question-image">
        {/* <img
          src={`https://www.coderoute.com/tests/${serieNbr}/${questionNbr}.jpg`}
          alt="question"
          loading="lazy"
        /> */}
        <CloudinaryImg url={url}/>
      </div>
      <div className="question-section">
        <span className="question-timer">
          <div key={questionNbr} className="image-question-nbr">
            {questionNbr}
          </div>
          <div className="timer-jauge"></div>
        </span>
        <span className="question-text">
          {q1 && <div className="question-value"> {`${q1} :`}</div>}
          <div style={choicesStyle}>
            {c1?.d && (
              <div
                className="question-choice"
                style={{ width: isSmallString ? "30%" : "60%" }}
              >
                {c1.d}
                <hr />1
              </div>
            )}
            {c2?.d && (
              <div
                className="question-choice"
                style={{ width: isSmallString ? "30%" : "60%" }}
              >
                {c2.d}
                <hr />2
              </div>
            )}
          </div>
          {q2 && <div className="question-value"> {`${q2} :`}</div>}
          <div style={choicesStyle}>
            {c3?.d && (
              <div
                className="question-choice"
                style={{ width: isSmallString ? "30%" : "60%" }}
              >
                {c3.d}
                <hr />3
              </div>
            )}
            {c4?.d && (
              <div
                className="question-choice"
                style={{ width: isSmallString ? "30%" : "60%" }}
              >
                {c4.d}
                <hr />4
              </div>
            )}
          </div>
        </span>
      </div>
    </>
  );
}
